import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    drawerContainer: {
      '& h2': {
        fontSize: '22px',
        fontWeight: 400,
      },
      '& .MuiDrawer-paper': {
        width: '900px',
        maxWidth: '90vw',
      },
      '& .MuiDrawer-paper > .MuiBox-root:first-of-type': {
        padding: '38px 0px 0px 32px !important',
      },
      '& .MuiDrawer-paper > .MuiBox-root': {
        padding: '0px 32px 32px 32px',
      },
    },
    drawerBody: {
      flexDirection: 'column',
      minHeight: 'calc(100vh - 180px)',
      justifyContent: 'space-between',
      fontWeight: 900,
    },
    detailsContainer: {
      margin: '24px 0px',
      border: '1px #EAEAEA solid',
      borderRadius: '10px',
      padding: '16px',
      fontWeight: 600,
      fontSize: '16px',
      '& .datePicker .MuiInput-input': {
        borderRadius: '4px',
      },
    },
    detailTable: {
      padding: '10px 20px 0px 20px',
      background: '#f7f7f7',
      borderRadius: '10px',

      '& .MuiTableBody-root tr': {
        borderBottom: '1px solid rgba(112, 112, 112, 0.1)', // Apply border to all rows
      },

      '& tr:last-child td:last-child': {
        color: '#1E8777 !important',
        fontWeight: 600,
      },

      '& .MuiTableBody-root tr:last-child': {
        borderBottom: 'none', // Remove bottom border for the last row
      },
    },
    icon: {
      verticalAlign: 'bottom',
      color: '#1E8777',
      background: '#F7F7F7',
      padding: '7px 9px',
      borderRadius: '5px',
      fontSize: '16px',
      marginRight: '10px',
    },
    buttonsContainer: {
      display: 'flex',
      gap: '8px',
      justifyContent: 'space-between',
      marginTop: 'auto',
      marginBottom: '15px',
    },
  }),
  { name: 'NewMassDrawdownDrawer' },
);

export default useStyles;
